export default __webpack_public_path__ + "static/media/login-username-icon.c893fc9e.svg";